<script setup>
import "@/assets/main.css";
import GetCountdownInBahasa from "@/components/countdowns/GetCoundownInBahasa.vue";
import { defineProps, computed } from "vue";
import { getStartTime } from "@/process/datetime/getStartTime";
import { generateTargetDate } from "@/process/datetime/generateTargetDate";
import { formatDateWithNoDay } from "@/process/datetime/formatDateWithNoDay";
import dayjs from "dayjs";

const props = defineProps({
    bgPath: {
        type: String,
            default: "bg-odesaktu",
            required:true,
    },
    rspDate: {
        type: String,
        // default: "18/10/2025",
        required:true,
    },
    rspTimeRange: {
        type: String,
        // default: "17.00 - Selesai",
        required:true,
    },
    venueAddress: {
        type: String,
        required:true,
    },
    mapsLink: {
        type: String,
        // default: "https://maps.app.goo.gl/CbDss5MtSvgskXvF7",
        required:true,
    }
})

const formattedRspDate = computed(() => formatDateWithNoDay(props.rspDate));

const rspTargetDate = computed(() =>
    generateTargetDate(props.rspDate, getStartTime(props.rspTimeRange))
);

let bgImage = require(`../../assets/photo/${props.bgPath}`);
</script>
<template>
    <div class="relative w-full flex flex-col justify-evenly">
        <div class="relative top-0 inset-0 h-6 w-full bg-gradient-to-b from-black to-transparent z-10 "></div>
        <div class="absolute inset-0 bg-black opacity-40 z-10"></div>
        <div class="absolute inset-0 z-0"><img
                :src="bgImage"
                class="object-cover absolute" 
                alt="..."
            />
        </div>
        <div class="text-off-white z-20 relative text-center">
            <p class="font-dynalight text-4xl tracking-widest leading-10 animated mt-10">
                Resepsi 
            </p>
        </div>
        <div
            class="relative z-20 flex flex-col text-center mx-5 my-10 pt-3 rounded-md bg-black/20 backdrop-blur-sm text-off-white animated">
            <div class="waktuPelaksanaan animated">
                <div class="waktuPelaksanaan animated">
                    <p class="font-dynalight text-2xl tracking-widest leading-10 mb-1">
                        {{dayjs(props.rspDate, "DD/MM/YYYY").format("dddd")}}
                    </p>
                    <div class="hariTanggal ">
                        <p class="bold">{{ formattedRspDate }}</p>
                        <p>{{ props.rspTimeRange }}</p>
                    </div>
                </div>
                <div class="hitungMundur flex mt-3 text-sm justify-center py-2 animated">
                    <GetCountdownInBahasa :targetDate="rspTargetDate" />
                </div>

                <div class="tempatPelaksanaan mt-6 mx-6 animated">
                    <h4>{{ props.venueAddress }}</h4>
                </div>

                <div class="googleMaps my-6 justify-center flex flex-col items-center">
                    <a :href="props.mapsLink" type="button"
                        class="z-20 animated border border-putih-keabuan/80 bg-putih-keabuan/10 px-5 py-2" target="_blank"
                        rel="noopener">
                        Google Maps
                    </a>
                    <iframe class="animated max-w-80 h-60 mt-10 rounded-md" src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3948.838369654725!2d115.0369552750096!3d-8.219004391813488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zOMKwMTMnMDguNCJTIDExNcKwMDInMjIuMyJF!5e0!3m2!1sen!2sid!4v1787351984416!5m2!1sen!2sid" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </div>
        <div class="relative inset-0 h-8 w-full bg-gradient-to-b from-transparent to-black/100 "></div>
    </div>
</template>
<style scoped>
</style>
